//- parent must be orders-planner-line
orders-planner-line-calendar
  .line
    .bg(style="background-image: url('/c/{opts.cells[0].year}/{opts.cells[0].month}.png'); left: -{(parseInt(opts.cells[0].day)-1)*20}px")
  script(type="typescript").
    this.mixin('orders.planner.planner');
